import React, { useContext, useState } from 'react';
import { useForm } from "react-hook-form";
import { format } from 'date-fns/esm';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contex/AuthProvider';


const AddBooks = () => {
    const { register, formState: { errors }, handleSubmit } = useForm();


    const imageHostkey = process.env.REACT_APP_imgbb_key;
    const { user } = useContext(AuthContext);

    const navigate = useNavigate();

    const handleAddBooks = data => {
        const image = data.image[0];
        const formData = new FormData();
        formData.append('image', image);
        const url = `https://api.imgbb.com/1/upload?key=${imageHostkey}`
        fetch(url, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(imageData => {

                if (imageData.success) {
                    const book = {
                        nameTitle: data.nameTitle,
                        category_id: data.id,
                        image: imageData.data.url,
                        originalPrice: data.originalPrice,
                        resalePrice: data.resalePrice,
                        useTime: data.useTime,
                        location: data.location,
                        sellerName: user?.displayName,
                        email: user?.email,
                        Post_date: format(new Date(), "PP"),
                        details: data.details,
                        condition: data.condition,
                        contact: data.contact,
                        isConfirm: false,
                        isAdvertise: false,

                    }
                    console.log(book);
                    fetch('https://assignment-12-server-beige.vercel.app/books', {
                        method: 'POST',
                        headers: {
                            'content-type': 'application/json',
                            authorization: `bearer ${localStorage.getItem('accessToken')}`
                        },
                        body: JSON.stringify(book)

                    })
                        .then(res => res.json())
                        .then(result => {

                            toast.success(`${data.name} is added successfully`);

                        })

                }

            })

    }

    return (
        <div>
            <form onSubmit={handleSubmit(handleAddBooks)}>
                <h2 className='text-3xl text-center font-semibold my-6'>Create Your Book Card</h2>

                <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4'>
                    <div className="form-control w-full ">
                        <label className="label"><span className="label-text">Book Name</span></label>
                        <input type="text" {...register("nameTitle", {
                            required: "Name is is required"
                        })} className="input input-bordered w-full " />
                        {errors.name && <p className='text-red-600'>{errors.name?.message}</p>}
                    </div>
                    <div className='form-control w-full max-w-xs mb-3'>
                        <label className="label"> <span className="label-text">Categori type</span></label>
                        <select type='text' {...register("id", {
                            required: 'Category is required'
                        })} className="select select-bordered w-full max-w-xs">

                            <option disabled selected>Select Your Book  Category</option>
                            <option value={'01'}>Law</option>
                            <option value={'02'}>Ict</option>
                            <option value={'03'}>Islamic</option>
                            <option value={'04'}>Economics</option>
                            <option value={'05'}>Engineering</option>
                        </select>
                        {errors.id && <p className='text-red-600'>{errors.id?.message}</p>}
                    </div>
                    <div className='form-control w-full max-w-xs mb-3'>
                        <label className="label"> <span className="label-text">Condition Type</span></label>
                        <select type='text' {...register("condition", {
                            required: 'Category is required'
                        })} className="select select-bordered w-full max-w-xs">

                            <option disabled selected>Select Your Book  Condition type</option>
                            <option value={'Good'}>Good</option>
                            <option value={'Excellent'}>Excellent</option>
                            <option value={'Fair'}>Fair</option>

                        </select>
                        {errors.condition && <p className='text-red-600'>{errors.condition?.message}</p>}
                    </div>
                    <div className="form-control w-full max-w-xs">
                        <label className="label"><span className="label-text">Photo</span></label>
                        <input type="file" {...register("image", {
                            required: "Photo is required"
                        })} className="input input-bordered w-full max-w-xs" />
                        {errors.img && <p className='text-red-600'>{errors.img?.message}</p>}
                    </div>
                    <div className="form-control w-full  max-w-xs">
                        <label className="label"><span className="label-text">Original price</span></label>
                        <input type="number" {...register("originalPrice", {
                            required: "originalPrice is required"
                        })} className="input input-bordered " />
                        {errors.originalPrice && <p className='text-red-600'>{errors.originalPrice?.message}</p>}
                    </div>
                    <div className="form-control w-full ">
                        <label className="label"><span className="label-text">Resale Price</span></label>
                        <input type="number" {...register("resalePrice", {
                            required: "resalePrice is required"
                        })} className="input input-bordered w-full max-w-xs" />
                        {errors.resalePrice && <p className='text-red-600'>{errors.resalePrice?.message}</p>}
                    </div>
                    <div className="form-control w-full ">
                        <label className="label"><span className="label-text">Year of using</span></label>
                        <input type="text" {...register("useTime", {
                            required: "using year is required"
                        })} className="input input-bordered w-full max-w-xs" />
                        {errors.useTime && <p className='text-red-600'>{errors.useTime?.message}</p>}
                    </div>
                    <div className="form-control w-full ">
                        <label className="label"><span className="label-text">Location</span></label>
                        <input type="text" {...register("location", {
                            required: "location is required"
                        })} className="input input-bordered w-full " />
                        {errors.location && <p className='text-red-600'>{errors.location?.message}</p>}
                    </div>

                    <div className="form-control w-full ">
                        <label className="label"><span className="label-text">Contact Number</span></label>

                        <input type="text" {...register("contact", {
                            required: "date is required"
                        })} className="input input-bordered w-full max-w-xs" />

                        {errors.contact && <p className='text-red-600'>{errors.contact?.message}</p>}
                    </div>

                    <div className="form-control w-full ">
                        <label className="label"><span className="label-text">Your book short description</span></label>
                        <textarea type="text" {...register("details", {
                            required: "details is required"
                        })} className="input input-bordered w-full " />
                        {errors.details && <p className='text-red-600'>{errors.details?.message}</p>}
                    </div>


                </div>

                <input className='btn mt-2' type="submit" value="Add Book" />
            </form>
        </div>
    );
};

export default AddBooks;